import { createContext, useContext, useMemo, useState } from "react";
import type { ReactNode } from "react";
interface HeaderButtonContextType {
  Comp: ReactNode | null;
  setComp: (comp: ReactNode | null) => void;
}

const HeaderButtonContext = createContext<HeaderButtonContextType | undefined>(
  undefined,
);

export function HeaderButtonProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  const [Comp, setComp] = useState<ReactNode | null>(null);

  const value = useMemo(() => ({ Comp, setComp }), [Comp, setComp]);

  return (
    <HeaderButtonContext.Provider value={value}>
      {children}
    </HeaderButtonContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useHeaderButton() {
  const context = useContext(HeaderButtonContext);
  if (context === undefined) {
    throw new Error(
      "useHeaderButton must be used within a HeaderButtonProvider",
    );
  }
  return context;
}
